export const renderKr = (x, label = 'kr.', maximumDigits = 0, minimumDigits = 0, showSmallMillion = false) => {
    if (x === undefined) {
        return 0;
    }
    if (showSmallMillion) {
        return `${Math.round(x / 1000000)} m.`;
    }
    if (maximumDigits === 0) {
        x = Math.round(x / 100) * 100;
    }
    return `${x.toLocaleString('da', {
        minimumFractionDigits: minimumDigits,
        maximumFractionDigits: maximumDigits,
    })}${label && ` ${label}`}`;
};

export function round(x, digits = 0) {
    return Math.round(x * 10**digits) / 10**digits;
}
export function renderPercent(x, maximumDigits = 2, minimumDigits = 0) {
    if (x === undefined) {
        return '0%';
    }
    return `${(x * 100).toLocaleString('da', {
        minimumFractionDigits: minimumDigits,
        maximumFractionDigits: maximumDigits,
    })}%`;
}
export const renderDate = date => (date ? `${date.day}/${date.month}/${date.year}` : '');
export function renderPeriod(period) {
    return `${renderDate(period.startDate)} - ${renderDate(period.endDate)}`;
}

export const renderLocaleDate = (dt, loc = 'da-DK') =>
    new Date(dt)
        .toLocaleDateString(loc)
        .replace('.', '/')
        .replace('.', '/');

export const renderShort = title => {
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(title);
    if (matches && !matches[1].includes('tidligere')) {
        return matches[1];
    }
    return title;
};

export const renderNumber = number => number.toString().replace('.', ',');

export const renderDateIntl = date => {
    const formatter = new Intl.DateTimeFormat('en-AU'); // en-AU uses 'dd/mm/yyyy' instead of da-DK 'dd.mm.yyyy'. - In danish both are accepted, but we prefer '/'
    return formatter.format(date);
};

export const renderDateLong = (date) => new Date(date).toLocaleDateString('da-DK', { weekday: 'long', month: 'long', day: 'numeric' });

export const renderTime = (date) => new Date(date).toLocaleString('da-DK', { hour: '2-digit', minute: '2-digit' });

export function renderDateTime(datetime) {
    let d = datetime;
    if(!d) return '';
    if (typeof d === 'number') d = new Date(datetime);
    if (typeof d === 'string') d = new Date(datetime);
    if (typeof d.toDate !== 'undefined') d = datetime.toDate();
    return d.toLocaleTimeString('da-DK', { year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit', minute:'2-digit' });
}
export function renderDateStandard(datetime) {
    let d = datetime;
    if(!d) return '';
    if (typeof d === 'number') d = new Date(datetime);
    if (typeof d === 'string') d = new Date(datetime);
    if (typeof d.toDate !== 'undefined') d = datetime.toDate();
    return d.toLocaleDateString('da-DK', { year: 'numeric', month: 'long', day: 'numeric' });
}
export function capitalizeFirstLetter(inputString) {
    if (typeof inputString !== 'string' || inputString.length === 0) {
        return inputString; // Return the original string if it's not a valid string or empty.
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
};
